const initialState = [];

export default (state = initialState, action = {}) => {
	switch(action.type) {
		case 'SET_PLACES':
			return { ...state, ...action.events }
		default:
			return state
	}
}